import axios from 'axios'
import type { SimpleItem } from 'BrokerTsLib/src/dtos'
import type { OkKlientSpec, User } from 'BrokerTsLib/src/dtos/User'
import type { GenericQueryOptions } from 'BrokerTsLib/src/hooks'
import { longStaleTime } from 'BrokerTsLib/src/hooks'
import { useQuery } from '@tanstack/react-query'

import { baseUrl } from '.'

const userApiUrl = import.meta.env.VITE_USER_API
const url = `${baseUrl}/${userApiUrl}`

const fetchUser = () => axios.get<User[]>(`${url}/GetUsers`)

export const useGetUsers = (options?: GenericQueryOptions<User[]>) =>
  useQuery({ queryKey: ['useGetAll'], queryFn: () => fetchUser(), staleTime: longStaleTime, ...options })

const fetchOu = () => axios.get<SimpleItem[]>(`${url}/GetOrganizationUnits`)

export const useGetOrganizationUnits = (options?: GenericQueryOptions<SimpleItem[]>) =>
  useQuery({ queryKey: ['useGetOrganizationUnits'], queryFn: () => fetchOu(), staleTime: longStaleTime, ...options })

export const fetchOkKlientSpec = () => axios.get<OkKlientSpec>(`${url}/BelongsToOkKlient`)
